<label class="radio-container" [class.inactive]="disabled">
  <input
    type="radio"
    [name]="name"
    [checked]="selected"
    [disabled]="disabled"
    (change)="select()"
    (blur)="onTouched()"
  />
  <hyperkit-typography class="label" variant="emphasized" size="sm">{{
    text
  }}</hyperkit-typography>
</label>
